// src/pages/PatreonCallback.tsx
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppContext } from "../context/AppContext";
import { toast } from "react-toastify";
import Preloader from "../components/Preloader";
import { linkPatreonToFirebaseUser } from "../util/PatreonUtil";

export const PatreonAuthCallback: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { SetPatreonAuthCallbackData } = useAppContext();

  useEffect(() => {
    // Parse the query parameters from the URL.
    const query = new URLSearchParams(location.search);
    const code = query.get("code");
    const firebaseToken = query.get("state");

    if (!code) {
      console.log("No Patreon code found in URL");
      toast.error("Linking failed.");
      navigate("/profile");
      return;
    }
    if (!firebaseToken) {
      console.log("No Firebase token found in URL");
      toast.error("Linking failed.");
      navigate("/profile");
      return;
    }

    SetPatreonAuthCallbackData({ code: code, state: firebaseToken });
    //navigate("/profile");

    // linkPatreonToFirebaseUser(firebaseToken, code).then((userData) => {
    //   if (userData) {
    //     // setPatreonId(userData.patreonId);
    //     // setPatreonTier(userData.patreonTier);
    //     // setPatronStatus(userData.patronStatus);
    //     // setHasFileAccess(userData.hasFileAccess);
    //     // refreshLibrary();
    //   } else {
    //     toast.error("Failed to link Patreon account.");
    //   }
    //   navigate("/profile");
    // });
    
  }, [location, navigate]);

  return ( <Preloader message="Linking Patreon..." /> );
};

export default PatreonAuthCallback;